package one.healthium.di

import kotlinx.serialization.json.Json
import kotlinx.serialization.modules.SerializersModule
import one.healthium.data.common.serializer.ColorSerializers
import one.healthium.data.health_log.AppHealthLogRepository
import one.healthium.data.paywall.AppPaywallRepository
import one.healthium.data.paywall.storage.LocalPaywallStorage
import one.healthium.data.user.AppUserRepository
import one.healthium.data.user.mapper.FoodLogMapper
import one.healthium.data.user.mapper.UserMapper
import one.healthium.data.user.storage.FirebaseAvatarStorage
import one.healthium.data.user.storage.FirebaseUserStorage
import one.healthium.data.user.storage.LocalUserStorage
import one.healthium.data.user.utils.SignInOptionsProvider
import one.healthium.domain.app_visit.AppVisitCounter
import one.healthium.domain.common.Color
import one.healthium.domain.health_log.HealthLogInteractor
import one.healthium.domain.health_log.HealthLogRepository
import one.healthium.domain.paywall.PaywallInteractor
import one.healthium.domain.paywall.PaywallRepository
import one.healthium.domain.paywall.models.PaywallScreenView
import one.healthium.domain.user.LogoutInteractor
import one.healthium.domain.user.UserInteractor
import one.healthium.domain.user.UserRepository
import one.healthium.domain.user.migration.UserMigrationManager
import one.healthium.healthKit.di.healthKitModule
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module

val sharedModule = module {
    includes(sharedPlatformModule(), healthKitModule)

    factoryOf(::ColorSerializers)
    single {
        val colorSerializers = get<ColorSerializers>()
        Json {
            ignoreUnknownKeys = true
            isLenient = true
            serializersModule = SerializersModule {
                include(PaywallScreenView.module)
                contextual(Color::class, colorSerializers)
            }
        }
    }

    factoryOf(::UserMapper)
    factoryOf(::FoodLogMapper)

    singleOf(::LocalUserStorage)
    singleOf(::FirebaseUserStorage)
    singleOf(::LocalPaywallStorage)
    singleOf(::SignInOptionsProvider)
    singleOf(::FirebaseAvatarStorage)

    singleOf(::AppUserRepository) bind UserRepository::class
    singleOf(::AppPaywallRepository) bind PaywallRepository::class
    singleOf(::AppHealthLogRepository) bind HealthLogRepository::class

    factoryOf(::UserInteractor)
    factoryOf(::LogoutInteractor)
    factoryOf(::PaywallInteractor)
    factoryOf(::HealthLogInteractor)

    singleOf(::UserMigrationManager)

    singleOf(::AppVisitCounter)
}